import { render, staticRenderFns } from "./ContactInfoWrapper.vue?vue&type=template&id=25909b79"
import script from "./ContactInfoWrapper.vue?vue&type=script&lang=js"
export * from "./ContactInfoWrapper.vue?vue&type=script&lang=js"
import style0 from "./ContactInfoWrapper.vue?vue&type=style&index=0&id=25909b79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports